import { Button, Grid2, Typography } from '@mui/material';
import type { ButtonProps } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { SCAN_APP_STORE_LINK, SCAN_GOOGLE_PLAY_LINK } from '@constants/scan';

import { HorizontalRule } from '@layouts/AuthLayout';

const messages = defineMessages({
  title: {
    id: 'scanAppModalContent.title',
    defaultMessage: 'Are you using Android (Google) or iOS (Apple)?',
  },
  android: {
    id: 'scanAppModalContent.android',
    defaultMessage: 'Android',
  },
  ios: {
    id: 'scanAppModalContent.ios',
    defaultMessage: 'iOS',
  },
  scanBarcode: {
    id: 'scanAppModalContent.scanBarcode',
    defaultMessage:
      'Scan the QR code to launch the app on your mobile/tablet device',
  },
});

type OperatingSystem = 'android' | 'ios';

export default function ScanAppModalContent() {
  const { formatMessage } = useIntl();
  const [operatingSystem, setOperatingSystem] =
    useState<OperatingSystem | null>(null);

  const setDeviceOperatingSystem = (system: OperatingSystem) =>
    setOperatingSystem(system);

  const baseButtonProps: ButtonProps = {
    fullWidth: true,
    size: 'large',
    variant: 'outlined',
  };

  return (
    <Grid2 container spacing={2} textAlign="center">
      <Grid2 size={{ xs: 12 }} sx={{ mt: 2 }}>
        <Typography variant="h6">{formatMessage(messages.title)}</Typography>
      </Grid2>

      <Grid2 size={{ xs: 6 }}>
        <Button
          {...baseButtonProps}
          onClick={() => setDeviceOperatingSystem('android')}
          sx={({ palette }) => ({
            borderRadius: '29px',
            backgroundColor:
              operatingSystem === 'android'
                ? palette.info.light
                : 'transparent',
          })}
        >
          {formatMessage(messages.android)}
        </Button>
      </Grid2>
      <Grid2 size={{ xs: 6 }}>
        <Button
          {...baseButtonProps}
          onClick={() => setDeviceOperatingSystem('ios')}
          sx={({ palette }) => ({
            borderRadius: '29px',
            backgroundColor:
              operatingSystem === 'ios' ? palette.info.light : 'transparent',
          })}
        >
          {formatMessage(messages.ios)}
        </Button>
      </Grid2>

      {operatingSystem && (
        <>
          <Grid2 size={{ xs: 12 }}>
            <HorizontalRule />
            <Typography variant="body1">
              {formatMessage(messages.scanBarcode)}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }} my={2}>
            <QRCodeSVG
              size={100}
              // TODO: Account for users who do not have app installed
              value={
                operatingSystem === 'ios'
                  ? SCAN_APP_STORE_LINK
                  : SCAN_GOOGLE_PLAY_LINK
              }
            />
          </Grid2>
        </>
      )}
    </Grid2>
  );
}
